import { render, staticRenderFns } from "./DraggableLists.vue?vue&type=template&id=142182fe&scoped=true&"
import script from "./DraggableLists.vue?vue&type=script&lang=js&"
export * from "./DraggableLists.vue?vue&type=script&lang=js&"
import style0 from "./DraggableLists.vue?vue&type=style&index=0&id=142182fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142182fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
